import { Button } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

/** Pill button of the intro landing page; colors are fixed design hex values (#006DB0 blue family) */
var IntroButton = function IntroButton(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      className = props.className,
      children = props.children,
      onClick = props.onClick;
  var variantClassName = {
    primary: 'bg-[#006DB0] text-white shadow-[0_10px_30px_-12px_rgba(0,109,176,0.6)] hover:bg-[#0A5E94]',
    outline: 'border border-solid border-[#006DB0] bg-white text-[#006DB0] hover:bg-[#EBF3F9]',
    white: 'bg-white text-[#006DB0] hover:bg-[#EBF3F9]',
    ghostOutline: 'border border-solid border-white/60 bg-transparent text-white hover:bg-white/10'
  }[variant];
  /**
   * methods
   */

  var clickAction = function clickAction() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };

  return /*#__PURE__*/_jsx(Button, {
    disableElevation: true,
    onClick: clickAction,
    className: clsx('rounded-full px-8 py-3 text-base font-bold normal-case transition-all duration-300 hover:-translate-y-0.5', variantClassName, className),
    children: children
  });
};

export default IntroButton;